<template>
  <div class="cropper">
    <div>
      <input ref="input" type="file" name="image" accept="image/*" @change="setImage"/>
      <div class="content">
        <div class="cropper-area">
          <vue-cropper
            ref="cropper"
            :aspectRatio="9 / 9"
            :src="(imgSrc) ? imgSrc : '/img/img-test-cropper.png'"
            preview=".preview"
            :viewMode="2"
            :autoCropArea="1"/>
        </div>
        <div class="preview-wrap">
          <div class="static">
          </div>
          <div class="actions-area">
            <div class="actions">
              <div class="alert-block">
                <div class="alert-block__message" >
                  <p>Please upload a picture</p>
                </div>
                <b-button type="blue-btn" role="button" @click.prevent="showFileChooser">Upload image</b-button>
              </div>
            </div>
          </div>
        </div>
        <div class="require-list">
          <p class="text-h3"><i style="color: #666; margin-right: 8px" class="fak fa-circle-info-light"/>Background Image Requirements</p>
          <ul class="text-p">
            <li>• The image must be at least 1920x1080 pixels</li>
            <li>• Your image will be cropped in the center at a ratio of 68% on desktops</li>
            <li>• Make sure that the information you want to see on your page is included in frame on the preview</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import VueCropper from 'vue-cropperjs';
import 'cropperjs/dist/cropper.css';
import axios from "axios";
import BButton from "@/components/__new_ui_kit/Button/BButton";
import api_requests from "../../store/api/api_requests";

export default {
  name: 'Cropper',
  components: {
    BButton,
    VueCropper
  },
  data() {
    return {
      flag: false,
      imgSrc: '',
      cropImg: '',
      data: null,
      image: '',
    };
  },
  props: ['show', 'uploadedImg'],
  methods: {
    // todo Это точно нужно переделать в нормальный вид
    cropImage() {
      return new Promise((resolve, reject) => {
        // get image data for post processing, e.g. upload or setting image src
        this.$refs.cropper.getCroppedCanvas({width: 1280, height: 720}).toBlob((blob) => {
          let data = new FormData();
          data.append('img', blob, 'cropped.png')
          api_requests.upload_img(data)
           .then(response => {
            this.image = response.data.path
            resolve();
          }).catch(error => {
            console.log(error)
            reject()
          })
        })

      })
    },
    reset() {
      this.$refs.cropper.reset();
    },
    rotate(deg) {
      this.$refs.cropper.rotate(deg);
    },
    setCropBoxData() {
      if (!this.data) return;
      this.$refs.cropper.setCropBoxData(JSON.parse(this.data));
    },
    setData() {
      if (!this.data) return;
      this.$refs.cropper.setData(JSON.parse(this.data));
    },
    setImage(e) {
      const file = e.target.files[0];
      if (file.type.indexOf('image/') === -1) {
        alert('Please select an image file');
        return;
      }
      if (typeof FileReader === 'function') {
        const reader = new FileReader();
        reader.onload = (event) => {
          this.imgSrc = event.target.result;
          this.$refs.cropper.replace(event.target.result);
        };
        reader.readAsDataURL(file);
      } else {
        alert('Sorry, FileReader API not supported');
      }
    },
    showFileChooser() {
      this.$refs.input.click();
    },
  },
  mounted() {
  },
  computed: {

  },
  watch: {
    image(newImage) {
      this.$emit('cover', newImage)
    },
  },
  created() {
    this.imgSrc = (this.uploadedImg) ? this.uploadedImg : '/img/img-test-cropper.png'
  }
};

</script>
<style lang="scss" scoped>;
.cropper {
  width: 100%;
  input[type="file"] {
    display: none;
  }
  .content {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-between;
    .preview-wrap {
      display: flex;
      flex-direction: row;
      align-items: flex-end;
      justify-content: flex-start;
      margin-top: 8px;
      .static {
        width: 400px;
        display: none;
        overflow: hidden;
        margin: 0 10px 0 0;
        img {
          width: 100%;
        }
      }
      .actions-area {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        .actions {
          margin: 0;
          span {
            color: red;
            font-size: 0.8em;
          }
          .alert-block {
            display: flex;
            align-items: center;
            flex-direction: row;
            &__message {
              background: #494949;
              position: relative;
              margin: 0 0 0 10px;
              border-radius: 3px;
              display: none;
              p {
                color: #ffffff;
                font-size: 0.85em;
                padding: 3px 10px;
                &::before {
                  position: absolute;
                  content: '';
                  left: -10px;
                  top: 10px;
                  border: 5px solid transparent;
                  border-right: 5px solid #494949;
                }
              }
            }
            img {
              margin: 10px 0 0 10px;
              cursor: pointer;
              &:hover + .alert-block__message {
                display: block;
              }
            }
          }
        }
      }
    }
    .cropper-area {
      width: 100%;
      @media(max-width: 640px) {
        width: 100%;
      }
    }
    .require-list {
      margin-top: 32px;
      display: flex;
      flex-direction: column;
      gap: 16px;
      ul {
        display: flex;
        flex-direction: column;
        gap: 8px;
      }
    }
  }
}
</style>